export const ru: Record<string, string> = {
  // ===== NAVIGATION =====
  'nav.dashboard': 'Главная',
  'nav.liveMap': 'Dispatcher',
  'nav.main': 'ОСНОВНОЕ',
  'nav.users': 'Пользователи',
  'nav.allUsers': 'Все',
  'nav.passengers': 'Пассажиры',
  'nav.drivers': 'Водители',
  'nav.documents': 'Документы',
  'nav.insurance': 'Страхование',
  'insurance.title': 'Срок страховки',
  'insurance.vehicle': 'Автомобиль',
  'insurance.techSery': 'Тех. серия',
  'insurance.techNumber': 'Тех. номер',
  'insurance.expiryDate': 'Дата окончания',
  'insurance.daysLeft': 'Осталось дней',
  'insurance.noData': 'Нет данных',
  'insurance.expiredPrefix': 'Истёк',
  'insurance.daysSuffix': 'дней назад',
  'insurance.expiresToday': 'Истекает сегодня',
  'insurance.daysLeftSuffix': 'дн. осталось',
  'insurance.sendPush': 'Отправить push',
  'insurance.sendPushTitle': 'Напоминание о страховке',
  'insurance.sendPushConfirm': 'Отправить водителю push-уведомление о сроке страховки?',
  'insurance.pushSent': 'Push-уведомление отправлено',
  'insurance.pushNoToken': 'Устройство водителя не подключено (нет FCM-токена)',
  'insurance.pushFailed': 'Не удалось отправить push-уведомление',
  'insurance.pickDate': 'Выбрать дату',
  'insurance.savedExpiry': 'Дата страховки сохранена',
  'insurance.saveFailed': 'Не удалось сохранить дату',
  'drivers.insuranceExpiry': 'Срок действия страховки',
  'common.notActive': 'Не активен',
  'insurance.lastReminder': 'Последнее уведомление',
  'insurance.history': 'История уведомлений',
  'insurance.historyTitle': 'История уведомлений',
  'insurance.historyEmpty': 'Уведомления ещё не отправлялись',
  'insurance.delivered': 'Доставлено',
  'insurance.notDelivered': 'Не доставлено',
  'insurance.cantNotifyNoData': 'Нет даты страховки — уведомление невозможно',
  'insurance.remindedThisWeek': 'Уведомлено за неделю',
  'insurance.reminderManual': 'Вручную',
  'insurance.reminderAuto2w': 'Авто · 2 нед.',
  'insurance.reminderAuto1w': 'Авто · 1 нед.',
  'insurance.reminderAuto1d': 'Авто · 1 день',
  'insurance.primaryVehicle': 'Основной',
  'insurance.driverUnverified': 'Не верифицирован',
  'insurance.pushTitleLabel': 'Заголовок',
  'insurance.pushBodyLabel': 'Текст',

  // Phase 3 — trip detail admin sections
  'trips.adminNotes': 'Заметки администратора',
  'trips.adminNotesPlaceholder': 'Напишите заметку...',
  'trips.adminNotesEmpty': 'Заметок пока нет',
  'trips.commissionTitle': 'Комиссия',
  'trips.commissionTaken': 'Удержано',
  'trips.commissionRefunded': 'Возвращено',
  'trips.driverNetEarnings': 'Чистый доход водителя',
  'trips.commissionStateDeducted': 'Удержано',
  'trips.commissionStateRefunded': 'Возвращено',
  'trips.commissionStateNone': 'Без комиссии',
  'trips.autoFindTimeline': 'История авто-поиска',
  'trips.autoFindTimelineEmpty': 'Событий пока нет',
  'trips.routeMap': 'Карта маршрута',
  'trips.routeMapLive': 'В реальном времени',
  'trips.pickup': 'Посадка',
  'trips.destination': 'Назначение',
  'trips.assignDriverTitle': 'Назначить водителя',
  'trips.assignDriverButton': 'Назначить водителя',
  'trips.replaceDriverTitle': 'Заменить водителя',
  'trips.replaceDriverButton': 'Заменить',
  'trips.currentDriver': 'Текущий водитель',
  'trips.noDriverAssigned': 'Водитель не назначен',
  'trips.driverSearchPlaceholder': 'Поиск по ID, имени или телефону',
  'trips.reassignReason': 'Причина замены',
  'trips.reassignReasonPlaceholder': 'Почему заменяется водитель?',
  'trips.reassignFinancialWarning':
    'Внимание: комиссия предыдущего водителя будет возвращена, с нового — удержана.',
  'trips.assignFinancialWarning': 'После назначения комиссия будет удержана с нового водителя.',
  'trips.autoFindLockoutHint':
    'Авто-поиск ещё работает (90 секунд). Дождитесь окончания или публичного режима.',
  'nav.trips': 'Поездки',
  'nav.allTrips': 'Все поездки',
  'nav.cancelledTrips': 'Отменённые поездки',
  'nav.driverTrips': 'Поездки водителей',
  'nav.bookings': 'Бронирования',
  'nav.yolYolakayOffers': 'Предложения торга',
  'nav.finance': 'ФИНАНСЫ',
  'nav.payments': 'Платежи водителей',
  'nav.pricing': 'Ценообразование',
  'nav.tariffs': 'Тарифы',
  'tariffs.title': 'Тарифы',
  'tariffs.name': 'Тариф',
  'tariffs.available': 'Активен',
  'tariffs.order': 'Порядок',
  'tariffs.saved': 'Сохранено',
  'tariffs.saveFailed': 'Не удалось сохранить',
  'tariffs.loadFailed': 'Не удалось загрузить тарифы',
  'tariffs.cars': 'Автомобили',
  'tariffs.trips': 'Поездки',
  'tariffs.inactive': 'Неактивен',
  'tariffs.allowedSeats': 'Места',
  'tariffs.allowedSeatsHint': 'Какие количества мест показывать в мобильном приложении',
  'tariffs.seatUnit': 'место',
  'tariffs.fullSalon': 'Весь салон',
  'tariffs.minPassengers': 'Мин. пассажиров',
  'tariffs.maxPassengers': 'Макс. пассажиров',
  'nav.amenities': 'Удобства',
  'amenities.title': 'Удобства',
  'amenities.name': 'Удобство',
  'amenities.available': 'Доступно',
  'amenities.saved': 'Сохранено',
  'amenities.saveFailed': 'Не удалось сохранить',
  'amenities.loadFailed': 'Не удалось загрузить удобства',
  'amenities.inactive': 'Неактивно',
  'amenities.hint':
    'Выключенные удобства не показываются водителю при создании линии',
  'amenities.AIR_CONDITIONER': 'Кондиционер',
  'amenities.MUSIC': 'Музыка',
  'amenities.NO_SMOKING': 'Не курить',
  'amenities.WOMEN_ONLY': 'Только женщины',
  'nav.promoCodes': 'Промокоды',
  'nav.trackingLinks': 'Маркетинговые ссылки',
  'trackingLinks.new': 'Новая ссылка',
  'trackingLinks.name': 'Название',
  'trackingLinks.channel': 'Канал',
  'trackingLinks.link': 'Ссылка',
  'trackingLinks.clicks': 'Клики',
  'trackingLinks.basicInfo': 'Основная информация',
  'nav.incentives': 'Поощрения',
  'nav.referrals': 'Реферальная программа',
  'nav.support': 'ПОДДЕРЖКА',
  'nav.supportTickets': 'Обращения',
  'nav.emergency': 'Экстренные чаты',
  'nav.suggestions': 'Предложения',
  'nav.chat': 'Сообщения',
  'nav.faq': 'FAQ',
  'nav.config': 'НАСТРОЙКИ',
  'nav.locations': 'Локации',
  'nav.tutorials': 'Руководства',
  'nav.carBrands': 'Марки авто',
  'nav.otp': 'OTP',
  'nav.cancellationReasons': 'Причины отмены',
  'nav.faollikBali': 'Балл активности',
  'nav.appUpdates': 'Обновления',
  'nav.notifications': 'Уведомления',
  'nav.staff': 'Сотрудники',
  'nav.auditLog': 'Журнал действий',
  'nav.withdrawals': 'Заявки на вывод',
  'nav.settings': 'Настройки',
  'nav.analytics': 'АНАЛИТИКА',
  'nav.analyticsPage': 'Аналитика',
  'nav.reports': 'Отчёты',
  'nav.callNotesAnalytics': 'Аналитика звонков',
  'nav.busCompanies': 'Компании',
  'nav.busCompanyProfile': 'Наши данные',
  'nav.busTrips': 'Рейсы',

  // ===== COMMON =====
  'common.search': 'Поиск...',
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.delete': 'Удалить',
  'common.edit': 'Редактировать',
  'common.create': 'Создать',
  'common.back': 'Назад',
  'common.view': 'Просмотр',
  'common.confirm': 'Подтвердить',
  'common.actions': 'Действия',
  'common.status': 'Статус',
  'common.date': 'Дата',
  'common.loading': 'Загрузка...',
  'common.noData': 'Нет данных',
  'common.total': 'Всего',
  'common.filtered': 'Найдено',
  'common.history': 'История',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.active': 'Активен',
  'common.inactive': 'Неактивен',
  'common.all': 'Все',
  'common.language': 'Язык',
  'common.today': 'Сегодня',
  'common.tomorrow': 'Завтра',
  'common.export': 'Экспорт',
  'common.send': 'Отправить',
  'common.close': 'Закрыть',
  'common.resolve': 'Решить',
  'common.approve': 'Одобрить',
  'common.reject': 'Отклонить',
  'common.block': 'Заблокировать',
  'common.unblock': 'Разблокировать',
  'common.error': 'Произошла ошибка',
  'common.success': 'Успешно',
  'common.logout': 'Выйти',
  'common.collapseMenu': 'Свернуть меню',
  'common.filter': 'Фильтр',
  'common.reset': 'Сбросить',
  'common.apply': 'Применить',
  'common.details': 'Подробности',
  'common.phone': 'Телефон',
  'common.name': 'Имя',
  'common.id': 'ID',
  'common.add': 'Добавить',
  'common.confirmDelete': 'Подтвердите удаление?',
  'common.driver': 'Водитель',
  'common.vehicle': 'Автомобиль',
  'common.createdAt': 'Создано',
  'common.updatedAt': 'Обновлено',
  'common.sum': 'сум',
  'common.reason': 'Причина',
  'common.description': 'Описание',
  'common.type': 'Тип',
  'common.price': 'Цена',
  'common.amount': 'Сумма',
  'common.noName': 'Без имени',

  // ===== TABLE COLUMNS =====
  'table.user': 'Пользователь',
  'table.role': 'Роль',
  'table.status': 'Статус',
  'table.rating': 'Рейтинг',
  'table.trips': 'Поездки',
  'table.registered': 'Зарегистрирован',
  'table.actions': 'Действия',
  'table.subject': 'Тема',
  'table.driver': 'Водитель',
  'table.client': 'Клиент',
  'table.route': 'Маршрут',
  'table.tripType': 'Тип поездки',
  'table.price': 'Цена',
  'table.date': 'Дата',
  'table.waitingTime': 'Время ожидания',
  'table.paymentMethod': 'Способ оплаты',
  'table.verified': 'Подтверждён',
  'table.license': 'Лицензия',

  // ===== STATUSES =====
  'status.online': 'Онлайн',
  'status.offline': 'Оффлайн',
  'status.blocked': 'Заблокирован',
  'status.resting': 'Отдыхает',
  'status.requested': 'Запрошена',
  'status.accepted': 'Принята',
  'status.driverArrived': 'Водитель прибыл',
  'status.pickedUp': 'Забран',
  'status.onTheWay': 'В пути',
  'status.inProgress': 'В процессе',
  'status.completed': 'Завершена',
  'status.cancelled': 'Отменена',
  'status.interrupted': 'Прервана',
  'status.noShow': 'Не явился',
  'status.active': 'Активен',
  'status.matched': 'Подобран',
  'status.expired': 'Истёк',
  'status.groupActive': 'Активные / в процессе',
  'status.groupDone': 'Завершённые',
  'status.groupCancelled': 'Отменённые / итог',
  'status.bucketWaiting': 'Запрошенные',
  'status.bucketActive': 'Активные / в пути',
  'status.bucketCompleted': 'Завершённые',
  'status.bucketCancelled': 'Отменённые',
  'status.open': 'Открыт',
  'status.inProgressTicket': 'В обработке',
  'status.resolved': 'Решён',
  'status.closed': 'Закрыт',
  'status.pending': 'Ожидает',
  'status.approved': 'Одобрен',
  'status.rejected': 'Отклонён',
  'status.new': 'Новый',
  'status.underReview': 'На рассмотрении',
  'status.accepted_suggestion': 'Принято',
  'status.closedSuggestion': 'Закрыто',

  // ===== ROLES =====
  'role.client': 'Клиент',
  'role.driver': 'Водитель',
  'role.admin': 'Админ',
  'role.passenger': 'Пассажир',

  // ===== TRIP TYPES =====
  'tripType.intercityTaxi': 'Междугороднее такси',
  'tripType.interregionTaxi': 'Межрегиональное такси',
  'tripType.shaharlarAro': 'Внутри региона',
  'tripType.yolYolakay': 'Торг',
  'tripType.postage': 'Почта/Доставка',
  'tripType.cargo': 'Крупный груз',

  // ===== PAYMENT =====
  'payment.cash': 'Наличные',
  'payment.uzcard': 'UzCard',
  'payment.humo': 'Humo',
  'payment.paid': 'Оплачен',
  'payment.unpaid': 'Не оплачен',

  // ===== DASHBOARD =====
  'dashboard.title': 'Главная',
  'dashboard.taxiManagement': 'Управление такси',
  'dashboard.busManagement': 'Управление автобусами',
  'dashboard.onlineDrivers': 'Водители онлайн',
  'dashboard.activeTrips': 'Активные поездки',
  'dashboard.todayRevenue': 'Доход за сегодня',
  'dashboard.commissionDeducted': 'Удержанные комиссии',
  'dashboard.driverTopups': 'Пополнения водителей',
  'dashboard.adminTopups': 'Пополнения админом',
  'dashboard.pendingDocs': 'Ожидающие документы',
  'dashboard.newUsers': 'Новые пользователи',
  'dashboard.openTickets': 'Открытые обращения',
  'dashboard.completedOrders': 'Завершённые заказы',
  'dashboard.completedOrders.interregion': 'Между регионами',
  'dashboard.completedOrders.shaharlarAro': 'Внутри региона',
  'dashboard.completedOrders.yolYolakay': 'Попутка',
  'dashboard.completedOrders.postage': 'Почта',
  'dashboard.comparedYesterday': 'по сравнению с прошлым периодом',
  'dashboard.range.today': 'Сегодня',
  'dashboard.range.yesterday': 'Вчера',
  'dashboard.range.thisWeek': 'Эта неделя',
  'dashboard.range.thisMonth': 'Этот месяц',
  'dashboard.range.thisYear': 'Этот год',
  'dashboard.range.allTime': 'Всё время',
  'dashboard.activeNow': 'Сейчас активно',
  'dashboard.viewOnMap': 'Смотреть на карте',
  'dashboard.quickActions': 'Быстрые действия',
  'dashboard.recentActivity': 'Последняя активность',
  'dashboard.noActivity': 'Нет активности',
  // Bus dashboard
  'dashboard.companies': 'Компании',
  'dashboard.totalCompanies': 'Всего компаний',
  'dashboard.activeCompanies': 'Активные компании',
  'dashboard.totalTrips': 'Всего рейсов',
  'dashboard.todayTrips': 'Рейсы сегодня',
  'dashboard.scheduledTrips': 'Запланированные рейсы',
  'dashboard.bookings': 'Бронирования',
  'dashboard.totalBookings': 'Всего бронирований',
  'dashboard.todayBookings': 'Бронирования сегодня',
  'dashboard.revenue': 'Доход',
  'dashboard.totalRevenue': 'Общий доход',
  // Audit log actions
  'audit.companyCreated': 'Компания создана',
  'audit.companyUpdated': 'Компания обновлена',
  'audit.tripCreated': 'Рейс создан',
  'audit.tripUpdated': 'Рейс обновлён',
  'audit.tripCancelled': 'Рейс отменён',
  'audit.bookingCreated': 'Бронирование создано',
  'audit.bookingConfirmed': 'Бронирование подтверждено',
  'audit.bookingCancelled': 'Бронирование отменено',
  'audit.stationCreated': 'Станция создана',
  'audit.layoutCreated': 'Схема создана',
  'audit.staffCreated': 'Сотрудник создан',
  'audit.staffUpdated': 'Сотрудник обновлён',
  'audit.staffDeleted': 'Сотрудник удалён',
  'audit.ticketReplied': 'Ответ на обращение',
  'audit.ticketResolved': 'Обращение решено',
  'audit.faqCreated': 'FAQ создан',
  'audit.faqUpdated': 'FAQ обновлён',
  'audit.promoCreated': 'Промокод создан',
  'audit.settingsUpdated': 'Настройки обновлены',
  'audit.walletTopup': 'Баланс пополнен',
  'audit.walletDeduct': 'Списание с баланса',

  // ===== USERS =====
  'usersStats.total': 'Всего пользователей',
  'usersStats.drivers': 'Водители',
  'usersStats.passengers': 'Пассажиры',
  'usersStats.online': 'Онлайн (водители + пассажиры)',
  'usersStats.blocked': 'Заблокированные',
  'usersStats.newThisMonth': 'Новых в этом месяце',

  'passengersStats.total': 'Всего пассажиров',
  'passengersStats.online': 'Онлайн',
  'passengersStats.blocked': 'Заблокированные',
  'passengersStats.newThisMonth': 'Новых в этом месяце',
  'passengersStats.totalTrips': 'Всего поездок',
  'passengersStats.averageRating': 'Средний рейтинг',

  'users.allUsers': 'Все пользователи',
  'users.title': 'Пользователи',
  'users.name': 'Полное имя',
  'users.phone': 'Телефон',
  'users.role': 'Роль',
  'users.rating': 'Рейтинг',
  'users.trips': 'Поездки',
  'users.registered': 'Зарегистрирован',
  'users.balance': 'Баланс',
  'users.viewAsPassenger': 'Как пассажир',
  'users.viewAsDriver': 'Как водитель',
  'users.signedUpAs': 'Изначально выбрано',
  'users.language': 'Язык',
  'users.roleNow': 'Сейчас',
  'users.roleInitial': 'Изначально',
  'users.bonusBalance': 'Бонусный баланс',
  'users.wallet': 'Кошелёк',
  'users.addFunds': 'Пополнить',
  'users.deductFunds': 'Списать',
  'users.blockUser': 'Заблокировать пользователя',
  'users.blockReason': 'Причина блокировки',
  'users.tripHistory': 'История поездок',
  'users.statistics': 'Статистика',
  'users.information': 'Информация',
  'users.editUser': 'Редактировать пользователя',
  'users.enterName': 'Введите имя',
  'users.nameRequired': 'Имя обязательно',
  'users.userBlocked': 'Пользователь заблокирован',
  'users.userUnblocked': 'Пользователь разблокирован',
  'users.userEdited': 'Пользователь отредактирован',
  'users.blockConfirm': 'Заблокировать пользователя?',
  'users.unblockConfirm': 'Разблокировать пользователя?',
  'users.blockReasonPlaceholder': 'Введите причину блокировки...',
  'users.enterBlockReason': 'Введите причину блокировки',
  'users.walletAddTitle': 'Пополнить баланс',
  'users.walletDeductTitle': 'Списать с баланса',
  'users.amountLabel': 'Сумма',
  'users.amountRequired': 'Сумма обязательна',
  'users.amountPositive': 'Сумма должна быть положительной',
  'users.reasonLabel': 'Причина',
  'users.reasonRequired': 'Причина обязательна',
  'users.balanceAdded': 'Баланс успешно пополнен',
  'users.balanceDeducted': 'Баланс успешно списан',
  'users.tripsNotFound': 'Поездки не найдены',

  // ===== PASSENGERS =====
  'passengers.title': 'Пассажиры',

  // ===== DRIVERS =====
  'drivers.title': 'Водители',
  'drivers.newDriver': 'Новый водитель',
  'drivers.verified': 'Подтверждён',
  'drivers.notVerified': 'Не подтверждён',
  'drivers.license': 'Лицензия',
  'drivers.licensed': 'Лицензирован',
  'drivers.unlicensed': 'Без лицензии',
  'drivers.licensedSet': 'Помечен как лицензированный',
  'drivers.unlicensedSet': 'Помечен как без лицензии',
  'drivers.verify': 'Подтвердить',
  'drivers.rejectDriver': 'Отклонить',
  'drivers.vehicle': 'Автомобиль',
  'drivers.transactions': 'Транзакции',
  'drivers.viewProfile': 'Просмотр профиля',
  'drivers.personalInfo': 'Личные данные',
  'drivers.personalInfoHelp': 'Личные данные водителя',
  'drivers.vehicleInfo': 'Данные автомобиля',
  'drivers.vehicleInfoHelp': 'Информация об автомобиле',
  'drivers.fullName': 'Полное имя',
  'drivers.fullNameHelp': 'Полное имя водителя',
  'drivers.enterName': 'Введите имя',
  'drivers.namePlaceholder': 'Например: Абдуллаев Жасур',
  'drivers.phoneNumber': 'Номер телефона',
  'drivers.phoneHelp': 'Номер телефона водителя',
  'drivers.enterPhone': 'Введите номер телефона',
  'drivers.birthDate': 'Дата рождения',
  'drivers.birthDateHelp': 'Дата рождения водителя',
  'drivers.selectDate': 'Выберите дату',
  'drivers.vehicleMake': 'Марка автомобиля',
  'drivers.vehicleMakeHelp': 'Производитель автомобиля',
  'drivers.enterMake': 'Введите марку',
  'drivers.makePlaceholder': 'Например: Chevrolet',
  'drivers.vehicleModel': 'Модель автомобиля',
  'drivers.vehicleModelHelp': 'Модель автомобиля',
  'drivers.enterModel': 'Введите модель',
  'drivers.modelPlaceholder': 'Например: Malibu',
  'drivers.vehicleYear': 'Год выпуска',
  'drivers.vehicleYearHelp': 'Год выпуска автомобиля',
  'drivers.enterYear': 'Введите год',
  'drivers.vehicleColor': 'Цвет автомобиля',
  'drivers.vehicleColorHelp': 'Цвет автомобиля',
  'drivers.enterColor': 'Введите цвет',
  'drivers.colorPlaceholder': 'Например: Белый',
  'drivers.vehiclePlate': 'Госномер',
  'drivers.vehiclePlateHelp': 'Государственный номер автомобиля',
  'drivers.enterPlate': 'Введите госномер',
  'drivers.vehicleSeats': 'Количество мест',
  'drivers.vehicleSeatsHelp': 'Доступные пассажирские места',
  'drivers.driverVerified': 'Водитель подтверждён',
  'drivers.driverBlocked': 'Водитель заблокирован',
  'drivers.driverUnblocked': 'Водитель разблокирован',
  'drivers.driverRejected': 'Водитель отклонён',
  'drivers.verifyConfirm': 'Подтвердить водителя?',
  'drivers.blockConfirm': 'Заблокировать водителя?',
  'drivers.unblockConfirm': 'Разблокировать водителя?',
  'drivers.walletBalance': 'Баланс кошелька',
  'drivers.addBalance': 'Пополнить баланс',
  'drivers.deductBalance': 'Списать с баланса',
  'drivers.vehicles': 'Автомобили',
  'drivers.transactionHistory': 'История транзакций',
  'drivers.documents': 'Документы',
  'drivers.tripHistory': 'История поездок',
  'drivers.rejectTitle': 'Отклонить водителя',
  'drivers.rejectReasonPlaceholder': 'Введите причину отклонения...',
  'drivers.enterRejectReason': 'Введите причину отклонения',
  // Transaction types
  'transaction.tripPayment': 'Оплата поездки',
  'transaction.commission': 'Комиссия',
  'transaction.walletTopup': 'Пополнение кошелька',
  'transaction.walletWithdrawal': 'Вывод средств',
  'transaction.bonus': 'Бонус',
  'transaction.bonusUsed': 'Использован бонус',
  'transaction.referralBonus': 'Реферальный бонус',
  'transaction.incentiveBonus': 'Бонус поощрения',
  'transaction.refund': 'Возврат',
  // Document types
  'document.driverLicense': 'Водительское удостоверение (лицевая)',
  'document.driverLicenseBack': 'Водительское удостоверение (обратная)',
  'document.selfie': 'Селфи',
  'document.techPassport': 'Техпаспорт (лицевая)',
  'document.techPassportBack': 'Техпаспорт (обратная)',
  'document.carFront': 'Авто спереди',
  'document.carBack': 'Авто сзади',
  'document.carLeft': 'Авто слева',
  'document.carRight': 'Авто справа',
  'document.carInterior': 'Салон авто',
  'document.carTrunk': 'Багажник',
  'document.carBackSeats': 'Задние сиденья',
  'document.carFrontSeat': 'Переднее сиденье',

  // Activity score reasons
  'activity.tripCompleted': 'Поездка завершена',
  'activity.fiveStarBonus': 'Бонус за 5 звёзд',
  'activity.fourStarBonus': 'Бонус за 4 звезды',
  'activity.lowRating2Star': 'Низкая оценка (2 звезды)',
  'activity.lowRating1Star': 'Низкая оценка (1 звезда)',
  'activity.driverCancelled': 'Водитель отменил',
  'activity.driverRejected': 'Водитель отклонил',
  'activity.driverNoShow': 'Водитель не явился',
  'activity.adminAdjustment': 'Корректировка администратора',
  'activity.blockRecoveryReset': 'Сброс после блокировки',
  'activity.autoBlocked': 'Автоблокировка',

  // Transaction types
  'transactionType.tripPayment': 'Оплата за поездку',
  'transactionType.commission': 'Комиссия',
  'transactionType.bonusCredit': 'Бонус зачислен',
  'transactionType.bonusDebit': 'Бонус списан',
  'transactionType.refund': 'Возврат',
  'transactionType.referralBonus': 'Реферальный бонус',
  'transactionType.incentiveBonus': 'Бонус поощрения',
  'transactionType.walletTopup': 'Пополнение кошелька',
  'transactionType.walletWithdrawal': 'Списание с кошелька',

  // ===== DOCUMENTS =====
  'documents.title': 'Документы',
  'documents.pending': 'Ожидает',
  'documents.approved': 'Одобрен',
  'documents.rejected': 'Отклонён',
  'documents.expiry': 'Срок действия',
  'documents.expiringSoon': 'Скоро истекает',
  'documents.expired': 'Просрочен',
  'documents.notSet': 'Не указан',
  'documents.approveAll': 'Одобрить все',
  'documents.rejectAll': 'Отклонить все',
  'documents.selected': 'выбрано',
  'documents.viewDriverProfile': 'Профиль водителя',
  'documents.userDocuments': 'Документы пользователя',
  'documents.image': 'Изображение',
  'documents.documentType': 'Тип документа',
  'documents.approveSuccess': 'Документ одобрен',
  'documents.rejectSuccess': 'Документ отклонён',
  'documents.replaceFile': 'Заменить файл',
  'documents.fileReplaced': 'Файл обновлён',
  'documents.missingDocuments': 'Не загруженные документы — может загрузить администратор',
  'documents.uploadSuccess': 'Документ загружен',

  // ===== TRIPS =====
  'trips.title': 'Поездки',
  'trips.newTrip': 'Новая поездка',
  'trips.tripDetails': 'Детали поездки',
  'trips.ratings': 'Оценки',
  'trips.pickup': 'Отправление',
  'trips.destination': 'Назначение',
  'trips.region': 'Регион',
  'trips.address': 'Адрес',
  'trips.negotiations': 'Торг (предложения водителей)',
  'trips.noNegotiations': 'Водители не оставили предложений по этой поездке',
  'trips.driverOfferCount': 'предл.',
  'trips.clientReplyCount': 'ответ',
  'trips.lastReply': 'Последний ответ',
  'trips.clientAccepted': 'Клиент принял',
  'trips.clientRejected': 'Клиент отклонил',
  'trips.matchedAtClientPrice': 'Согласовано по цене клиента (не по предложению водителя)',
  'trips.clientNoResponse': 'Нет ответа',
  'trips.chatMessages': 'Сообщения чата',
  'trips.chatLoadError': 'Ошибка загрузки сообщений',
  'trips.loadError': 'Ошибка загрузки поездок',
  'trips.searchPlaceholder': 'Клиент/водитель/телефон...',
  'cancelledTrips.title': 'Отменённые поездки',
  'cancelledTrips.waitTime': 'Время ожидания клиента',
  'trips.route': 'Маршрут',
  'trips.payment': 'Оплата',
  'trips.timeline': 'Хронология',
  'trips.statusEventsTitle': 'Журнал статусов (с GPS)',
  'tripEvent.onTheWay': 'Выехал, чтобы забрать клиента',
  'tripEvent.arrived': 'Прибыл к клиенту',
  'tripEvent.inProgress': 'Забрал клиента — едет к месту назначения',
  'tripEvent.completed': 'Завершил поездку',
  'trips.noGps': 'Нет GPS',
  'trips.passengerCount': 'Количество пассажиров',
  'trips.pickupRegion': 'Регион отправления',
  'trips.pickupAddress': 'Адрес отправления',
  'trips.destinationRegion': 'Регион назначения',
  'trips.destinationAddress': 'Адрес назначения',
  'trips.distance': 'Расстояние',
  'trips.estimatedTime': 'Расчётное время',
  'trips.estimatedPrice': 'Расчётная цена',
  'trips.clientOffer': 'Предложение клиента',
  'trips.finalPrice': 'Итоговая цена',
  'trips.paymentMethod': 'Способ оплаты',
  'trips.surgeMultiplier': 'Коэффициент Surge',
  'trips.forceCancel': 'Принудительная отмена',
  'trips.forceComplete': 'Принудительное завершение',
  'trips.forceCancelConfirm': 'Принудительно отменить поездку?',
  'trips.forceCompleteConfirm': 'Принудительно завершить поездку?',
  'trips.tripCancelled': 'Поездка отменена',
  'trips.tripCompleted': 'Поездка завершена',
  'trips.cancelledBy': 'Отменил',
  'trips.cancelActor.client': 'Клиент',
  'trips.cancelActor.driver': 'Водитель',
  'trips.cancelActor.admin': 'Администратор',
  'trips.cancelActor.system': 'Система',
  'trips.cancelReason': 'Причина отмены',
  'trips.cancelNote': 'Примечание',
  'trips.clientInfo': 'Данные клиента',
  'trips.driverInfo': 'Данные водителя',
  'trips.vehicleInfo': 'Данные автомобиля',
  'trips.vehicleMakeModel': 'Марка и модель',
  'trips.vehiclePlate': 'Госномер',
  'trips.vehicleColor': 'Цвет',
  'trips.addRating': 'Добавить оценку',
  'trips.whoRates': 'Кто оценивает',
  'trips.ratingScore': 'Балл',
  'trips.ratingComment': 'Комментарий',
  'trips.ratingAdded': 'Оценка добавлена',
  'trips.noRatings': 'Нет оценок',
  'trips.noChatMessages': 'Нет сообщений',
  'trips.waitingTime': 'Время ожидания',
  'trips.driverWaitTime': 'Ожидание водителя',
  'trips.tripDuration': 'Длительность поездки',
  'trips.tariff': 'Тариф',
  'trips.scheduledTime': 'Запланированное время',
  'trips.departureTime': 'Время выезда',
  'trips.tripType': 'Тип поездки',
  'trips.client': 'Клиент',
  'trips.driver': 'Водитель',
  'trips.price': 'Цена',
  // Time units
  'time.day': 'дн.',
  'time.hour': 'ч.',
  'time.minute': 'мин.',
  'time.second': 'сек.',
  // Yol-yolakay specific
  'trips.datePreference': 'Предпочтение по дате',
  'trips.preferredTime': 'Предпочтительное время',
  'trips.showOnMap': 'Показать на карте',
  'trips.comment': 'Комментарий',
  'trips.expiration': 'Срок действия',
  'trips.targetDriver': 'Целевой водитель',
  'trips.dateNow': 'Сейчас',
  'trips.dateToday': 'Сегодня',
  'trips.dateTomorrow': 'Завтра',
  // Additional trip destinations
  'trips.destinations': 'Пункты назначения',
  'trips.moreDestinations': 'Дополнительные пункты назначения',

  // ===== LIVE MAP =====
  'liveMap.title': 'Карта в реальном времени',
  'liveMap.realtime': 'Реальное время',
  'liveMap.drivers': 'Водители',
  'liveMap.trips': 'Поездки',
  'liveMap.regionFrom': 'Откуда',
  'liveMap.regionTo': 'Куда',
  'liveMap.region': 'Регион (фокус)',
  'liveMap.searchDriver': 'Поиск водителя',
  'liveMap.noOnlineDrivers': 'Онлайн-водитель не найден',
  'liveMap.onlineDrivers': 'Водители онлайн',
  'liveMap.activeTrips': 'Активные поездки',
  'liveMap.pendingRequests': 'Ожидающие запросы',
  'liveMap.regionStats': 'Статистика по регионам',
  'liveMap.connected': 'Подключено',
  'liveMap.disconnected': 'Отключено',
  'liveMap.reconnecting': 'Переподключение',
  'liveMap.driverPhone': 'Телефон водителя',
  'liveMap.driverStatus': 'Статус водителя',
  'liveMap.driverVehicle': 'Автомобиль водителя',
  'liveMap.lastUpdate': 'Последнее обновление',
  'liveMap.viewProfile': 'Просмотр профиля',
  'liveMap.tripId': 'ID поездки',
  'liveMap.tripType': 'Тип поездки',
  'liveMap.tripStatus': 'Статус поездки',
  'liveMap.tripClient': 'Клиент',
  'liveMap.tripDriver': 'Водитель',
  'liveMap.tripPickup': 'Точка отправления',
  'liveMap.tripDestination': 'Точка назначения',
  'liveMap.tripDetails': 'Детали поездки',
  'liveMap.noActiveTrips': 'Нет активных поездок',
  'liveMap.noOnlineDrivers': 'Нет водителей онлайн',
  'liveMap.driverCount': 'Количество водителей',
  'liveMap.tripCount': 'Количество поездок',
  'liveMap.postedTrips': 'Опубликованные поездки',
  'liveMap.noPostedTrips': 'Нет активных опубликованных поездок',
  'liveMap.viloyatlarAro': 'Между регионами',
  'liveMap.viloyatIchida': 'Внутри региона',
  'liveMap.seatsLeft': 'свободно',
  'liveMap.postedStatus.ACTIVE': 'Активна',
  'liveMap.postedStatus.FULL': 'Заполнена',
  'liveMap.postedStatus.DEPARTED': 'В пути',
  'liveMap.openProfile': 'Открыть профиль в новой вкладке',
  'liveMap.openTrip': 'Открыть поездку в новой вкладке',
  'liveMap.activePostedTrip': 'Активная поездка',
  'liveMap.noActivePostedTrip': 'Нет активной поездки',
  'liveMap.fullscreen': 'Полноэкранный режим',
  'liveMap.exitFullscreen': 'Выйти из полноэкранного режима (Esc)',

  // ===== DISPATCHER =====
  'dispatcher.title': 'Dispatcher',
  'dispatcher.exit': 'Выход',
  'dispatcher.orders': 'Заказы',
  'dispatcher.activeOrders': 'Активные заказы',
  'dispatcher.pendingRequests': 'Запросы (ожидают водителя)',
  'dispatcher.postedRides': 'Объявления водителей',
  'dispatcher.pickup': 'Подача',
  'dispatcher.destination': 'Назначение',
  'dispatcher.client': 'Клиент',
  'dispatcher.driver': 'Водитель',
  'dispatcher.unassigned': 'Не назначен',
  'dispatcher.waitingTime': 'Ожидание',
  'dispatcher.call': 'Позвонить',
  'dispatcher.price': 'Цена',
  'dispatcher.paymentMethod': 'Оплата',
  'dispatcher.passengers': 'Пассажиры',
  'dispatcher.rating': 'Рейтинг',
  'dispatcher.verified': 'Проверен',
  'dispatcher.notVerified': 'Не проверен',
  'dispatcher.licensed': 'Лицензирован',
  'dispatcher.activityScore': 'Балл активности',
  'dispatcher.vehicle': 'Автомобиль',
  'dispatcher.plate': 'Гос. номер',
  'dispatcher.color': 'Цвет',
  'dispatcher.seats': 'Места',
  'dispatcher.year': 'Год',
  'dispatcher.speed': 'Скорость',
  'dispatcher.lastSeen': 'Последнее обновление',
  'dispatcher.allowedTariffs': 'Тарифы',
  'dispatcher.allowedServices': 'Услуги',
  'dispatcher.currentTrip': 'Текущая поездка',
  'dispatcher.noCurrentTrip': 'Сейчас не в поездке',
  'dispatcher.noSelection': 'Выберите машину или заказ для деталей',
  'dispatcher.onlineDrivers': 'Водители онлайн',
  'dispatcher.regionStats': 'По регионам',
  'dispatcher.viewFullTrip': 'Полная поездка',
  'dispatcher.viewProfile': 'Профиль',
  'dispatcher.resting': 'Отдыхает',
  'dispatcher.clearSelection': 'Сбросить выбор (Esc)',
  'dispatcher.totalTrips': 'Всего поездок',
  'dispatcher.acceptanceRate': 'Уровень принятия',
  'dispatcher.noOrders': 'Нет активных заказов',
  'dispatcher.searchDriver': 'Поиск водителя',
  'dispatcher.focusRegion': 'Центр на регион',

  // ===== SETTINGS =====
  'settings.title': 'Настройки',
  'settings.save': 'Сохранить',
  'settings.saveConfirm': 'Сохранить настройки?',
  'settings.saved': 'Настройки сохранены',
  'settings.fillForm': 'Заполните все поля',
  'settings.commission': 'Комиссия',
  'settings.commissionHelp': 'Процент комиссии с каждого типа поездки',
  'settings.intercityCommission': 'Междугородняя комиссия',
  'settings.interregionCommission': 'Межрегиональная комиссия',
  'settings.postageCommission': 'Комиссия почты',
  'settings.cargoCommission': 'Комиссия грузов',
  'settings.autoFind': 'Авто-поиск',
  'settings.autoFindHelp': 'Настройки автоматического поиска водителей',
  'settings.offerTimeout': 'Таймаут предложения',
  'settings.progressiveOffer': 'Прогрессивное предложение',
  'settings.maxDrivers': 'Максимум водителей',
  'settings.searchRadius': 'Радиус поиска',
  'settings.negotiation': 'Переговоры',
  'settings.negotiationHelp': 'Настройки переговоров о цене',
  'settings.maxCounterOffers': 'Максимум встречных предложений',
  'settings.counterOfferTimeout': 'Таймаут встречного предложения',
  'settings.driverSettings': 'Настройки водителя',
  'settings.driverSettingsHelp': 'Общие настройки для водителей',
  'settings.osago': 'Страхование (ОСАГО)',
  'settings.osagoHelp':
    'Включение/выключение сервиса страхования и каждой страховой компании. При выключении кнопка "Страховка" скрывается в приложениях клиента и водителя.',
  'settings.osagoEnabled': 'Сервис страхования',
  'settings.osagoGrossEnabled': 'Gross',
  'settings.osagoKafolatEnabled': 'Kafolat',
  'settings.osagoDefaultProvider': 'Страховая компания по умолчанию',
  'settings.osagoDefaultProviderHelp':
    'Страховая компания, выбираемая в приложении по умолчанию. Если она отключена, выбирается первая включённая компания.',
  'settings.minRating': 'Минимальный рейтинг',
  'settings.maxCancellations': 'Максимум отмен',
  'settings.blockDuration': 'Длительность блокировки',
  'settings.cancellationPenalty': 'Штраф за отмену',
  'settings.surgePricing': 'Динамическое ценообразование',
  'settings.surgePricingHelp': 'Динамическое ценообразование при высоком спросе',
  'settings.enabled': 'Включено',
  'settings.surgeThreshold': 'Порог Surge',
  'settings.surgeMin': 'Минимальный Surge',
  'settings.surgeMax': 'Максимальный Surge',
  'settings.nightPricing': 'Ночные цены',
  'settings.nightPricingHelp': 'Надбавка в ночное время',
  'settings.nightMultiplier': 'Ночной коэффициент',
  'settings.nightStart': 'Начало ночного тарифа',
  'settings.nightEnd': 'Конец ночного тарифа',
  'settings.nightTimeHint': 'Формат: ЧЧ:ММ (например, 22:00)',
  'settings.referralBonuses': 'Реферальные бонусы',
  'settings.referralBonusesHelp': 'Настройки бонусов реферальной программы',
  'settings.referralClient': 'Бонус клиенту',
  'settings.referralDriver': 'Бонус водителю',
  'settings.clientSettings': 'Настройки клиента',
  'settings.clientSettingsHelp': 'Общие настройки для клиентов',
  'settings.clientCancellationPenalty': 'Штраф за отмену клиентом',
  'settings.clientNoShowWait': 'Ожидание при неявке',
  'settings.postageLimits': 'Лимиты почты и грузов',
  'settings.postageLimitsHelp': 'Ограничения доставки почты и грузов',
  'settings.maxDestinations': 'Максимум адресов',
  'settings.maxWeight': 'Максимальный вес',
  'settings.limits': 'Лимиты',
  'settings.limitsHelp': 'Общие системные ограничения',
  'settings.maxTripDistance': 'Максимальное расстояние поездки',
  'settings.locationUpdateInterval': 'Интервал обновления локации',

  // ===== NOTIFICATIONS =====
  'notifications.title': 'Уведомления',
  'notifications.send': 'Отправить уведомление',
  'notifications.sendTitle': 'Отправка уведомления',
  'notifications.targetType': 'Кому отправить',
  'notifications.allUsers': 'Только клиентам (пассажирам)',
  'notifications.allDrivers': 'Только водителям',
  'notifications.byRegion': 'По региону',
  'notifications.singleUser': 'Одному пользователю',
  'notifications.regionLabel': 'Регион',
  'notifications.selectRegion': 'Выберите регион',
  'notifications.userId': 'ID пользователя',
  'notifications.enterUserId': 'Введите ID пользователя',
  'notifications.notificationTitle': 'Заголовок',
  'notifications.titlePlaceholder': 'Заголовок уведомления...',
  'notifications.body': 'Текст',
  'notifications.bodyPlaceholder': 'Текст уведомления...',
  'notifications.schedule': 'Запланировать',
  'notifications.cancelSchedule': 'Отменить расписание',
  'notifications.sendNow': 'Отправить сейчас',
  'notifications.scheduledSend': 'Запланированная отправка',
  'notifications.selectTime': 'Выберите время',
  'notifications.willSendNow': 'Будет отправлено сейчас',
  'notifications.willSendScheduled': 'Будет отправлено в указанное время',
  'notifications.broadcastConfirm': 'Отправить массовое уведомление?',
  'notifications.broadcastToUsers': 'Будет отправлено только клиентам (пассажирам)',
  'notifications.broadcastToDrivers': 'Будет отправлено только водителям',
  'notifications.sentSuccess': 'Уведомление отправлено',
  'notifications.scheduledSuccess': 'Уведомление запланировано',
  'notifications.sendError': 'Ошибка отправки',
  'notifications.stats.totalSent': 'Всего отправлено',
  'notifications.stats.delivered': 'Доставлено',
  'notifications.stats.read': 'Прочитано',
  'notifications.stats.todaySent': 'Отправлено сегодня',
  'notifications.historyTab': 'История',
  'notifications.templatesTab': 'Шаблоны',
  'notifications.templateName': 'Название шаблона',
  'notifications.templateNamePlaceholder': 'Введите название шаблона...',
  'notifications.category': 'Категория',
  'notifications.categoryPromo': 'Реклама',
  'notifications.categoryNews': 'Новости',
  'notifications.categorySystem': 'Системное',
  'notifications.categoryReminder': 'Напоминание',
  'notifications.newTemplate': 'Новый шаблон',
  'notifications.editTemplate': 'Редактировать шаблон',
  'notifications.templateCreated': 'Шаблон создан',
  'notifications.templateUpdated': 'Шаблон обновлён',
  'notifications.templateDeleted': 'Шаблон удалён',
  'notifications.templateDeleteError': 'Ошибка удаления шаблона',
  'notifications.recipients': 'Получатели',
  'notifications.sentCount': 'Отправлено',
  'notifications.audienceFilters': 'Фильтры аудитории',
  'notifications.recipientsFound': 'получателей',
  'notifications.excludeBlocked': 'Исключить заблокированных',
  'notifications.inactiveDays': 'Не активны (дней)',
  'notifications.inactiveDaysPlaceholder': 'Все (без ограничений)',
  'notifications.hasDocuments': 'Отправил документы',
  'notifications.docsNotSent': 'Нет (не отправил)',
  'notifications.deliveredCount': 'Доставлено',
  'notifications.readCount': 'Прочитано',
  'notifications.sender': 'Отправитель',

  // ===== SUPPORT =====
  'support.title': 'Обращения',
  'support.ticketDetails': 'Детали обращения',
  'support.relatedTrip': 'Связанная поездка',
  'support.viewTrip': 'Посмотреть поездку',
  'support.viewFullTrip': 'Полная информация о поездке',
  'support.messages': 'Сообщения',
  'support.replySection': 'Написать ответ',
  'support.replyPlaceholder': 'Введите ваш ответ...',
  'support.replySuccess': 'Ответ отправлен',
  'support.resolveSuccess': 'Обращение решено',
  'support.resolveButton': 'Решить',
  'support.ticketSubject': 'Тема',
  'support.ticketUser': 'Пользователь',
  'support.ticketStatus': 'Статус',
  'support.ticketDate': 'Дата',
  'support.statusOpen': 'Открыт',
  'support.statusInProgress': 'В обработке',
  'support.statusResolved': 'Решён',
  'support.statusClosed': 'Закрыт',

  // ===== EMERGENCY =====
  'emergency.title': 'Экстренные чаты',
  'emergency.alert': 'Экстренное сообщение',
  'emergency.alertDescription': 'Пользователь запросил экстренную помощь',
  'emergency.lastMessage': 'Последнее сообщение',
  'emergency.ctrlEnterHint': 'Нажмите Ctrl+Enter для отправки',

  // ===== SUGGESTIONS =====
  'suggestions.title': 'Предложения',
  'suggestions.statusNew': 'Новое',
  'suggestions.statusUnderReview': 'На рассмотрении',
  'suggestions.statusAccepted': 'Принято',
  'suggestions.statusClosed': 'Закрыто',
  'suggestions.accept': 'Принять',
  'suggestions.replySection': 'Написать ответ',
  'suggestions.category': 'Категория',
  'suggestions.preview': 'Текст',
  'suggestions.content': 'Текст предложения',

  // ===== PAYMENTS =====
  'payments.title': 'Платежи водителей',
  'payments.searchPlaceholder': 'Поиск платежей...',
  'payments.paymentDetails': 'Детали платежа',
  'payments.refundConfirm': 'Вернуть платёж?',
  'payments.refundButton': 'Возврат',
  'payments.refundSuccess': 'Платёж успешно возвращён',
  'payments.refundError': 'Ошибка возврата платежа',
  'payments.loadError': 'Ошибка загрузки платежей',
  'payments.transactionLoadError': 'Ошибка загрузки транзакций',
  'payments.transactionHistory': 'История транзакций',
  'payments.originalAmount': 'Исходная сумма',
  'payments.bonusUsed': 'Использовано бонусов',
  'payments.promoDiscount': 'Промо-скидка',
  'payments.finalAmount': 'Итоговая сумма',
  'payments.externalId': 'Внешний ID',
  'payments.completedAt': 'Время завершения',
  'payments.statusPending': 'Ожидает',
  'payments.statusProcessing': 'Обрабатывается',
  'payments.statusCompleted': 'Завершён',
  'payments.statusFailed': 'Ошибка',
  'payments.statusRefunded': 'Возвращён',
  'payments.viewWithDriver': 'Реальные платежи',
  'payments.viewNoDriver': 'Неудачные / ожидающие',
  'payments.viewAll': 'Все',
  'payments.viewTopups': 'Пополнения',
  'payments.viewWithdrawals': 'Выводы',
  'payments.topup': 'Пополнение счёта',
  'payments.withdrawal': 'Вывод на карту',
  'payments.atmosId': 'ATMOS ID',
  'payments.source': 'Источник',
  'payments.sourceAll': 'Все',
  'payments.sourceAtmos': 'ATMOS',
  'payments.sourceAdmin': 'Админ',
  'payments.sourceOther': 'Другое',

  // ===== ANALYTICS =====
  'analytics.title': 'Аналитика',
  'analytics.exportExcel': 'Экспорт в Excel',
  'analytics.dateRange': 'Период',
  'analytics.revenueTab': 'Доход',
  'analytics.tripsTab': 'Поездки',
  'analytics.usersTab': 'Пользователи',
  'analytics.driversTab': 'Водители',
  'analytics.regionsTab': 'Регионы',
  'analytics.totalRevenue': 'Общий доход',
  'analytics.avgDaily': 'Средний дневной',
  'analytics.growth': 'Рост',
  'analytics.revenueChart': 'График дохода',
  'analytics.noRevenueData': 'Нет данных о доходе',
  'analytics.totalTrips': 'Всего поездок',
  'analytics.completedTrips': 'Завершённые поездки',
  'analytics.cancelledTrips': 'Отменённые поездки',
  'analytics.tripsChart': 'График поездок',
  'analytics.noTripsData': 'Нет данных о поездках',
  'analytics.tripsByType': 'Поездки по типам',
  'analytics.totalUsers': 'Всего пользователей',
  'analytics.totalDrivers': 'Всего водителей',
  'analytics.userGrowth': 'Рост пользователей',
  'analytics.newUsers': 'Новые пользователи',
  'analytics.newDrivers': 'Новые водители',
  'analytics.avgRating': 'Средний рейтинг',
  'analytics.avgTrips': 'Среднее кол-во поездок',
  'analytics.driverStatus': 'Статус водителей',
  'analytics.topDrivers': 'Лучшие водители',
  'analytics.driverPerformance': 'Производительность водителей',
  'analytics.avgResponseTime': 'Среднее время ответа',
  'analytics.acceptanceRate': 'Процент принятия',
  'analytics.completionRate': 'Процент завершения',
  'analytics.regionTrips': 'Поездки по регионам',
  'analytics.regionRevenue': 'Доход по регионам',
  'analytics.regionDrivers': 'Водители по регионам',
  'analytics.regionStats': 'Статистика по регионам',
  // Bus analytics
  'analytics.busTitle': 'Аналитика автобусов',
  'analytics.paidAmount': 'Оплаченная сумма',
  'analytics.unpaidAmount': 'Неоплаченная сумма',
  'analytics.commission': 'Комиссия',
  'analytics.bookedSeats': 'Забронированные места',
  'analytics.totalSeats': 'Всего мест',
  'analytics.occupancyRate': 'Заполняемость',
  'analytics.routesTab': 'Маршруты',
  'analytics.companiesTab': 'Компании',
  'analytics.revenueByRoute': 'Доход по маршрутам',
  'analytics.routeStats': 'Статистика маршрутов',
  'analytics.revenueByCompany': 'Доход по компаниям',
  'analytics.companyStats': 'Статистика компаний',
  'analytics.loadError': 'Ошибка загрузки аналитики',

  // ===== ANALYTICS v2 =====
  'analytics.refresh': 'Обновить',
  'analytics.period': 'Период',
  'analytics.periodDaily': 'Ежедневно',
  'analytics.periodWeekly': 'Еженедельно',
  'analytics.periodMonthly': 'Ежемесячно',
  'analytics.noData': 'Нет данных',

  'analytics.kpi.grossRevenue': 'Валовая выручка',
  'analytics.kpi.grossRevenueHint': 'Заработок водителей (без отменённых поездок)',
  'analytics.kpi.grossCommission': 'Комиссия',
  'analytics.kpi.grossCommissionHint': 'Доля платформы (до выплат)',
  'analytics.kpi.netMargin': 'Чистая прибыль',
  'analytics.kpi.netMarginHint': 'Пополнения через платёжную систему (минус 1% налог; ручные начисления не учитываются)',
  'analytics.kpi.driverIncentives': 'Выплаты водителям',
  'analytics.kpi.userBonuses': 'Бонусы пользователям',
  'analytics.kpi.promoDiscounts': 'Промо-скидки',
  'analytics.kpi.refunds': 'Возвраты',
  'analytics.kpi.totalTrips': 'Всего поездок',
  'analytics.kpi.completionRate': 'Процент завершения поездок',
  'analytics.verificationByOperator': 'Процент одобрения водителей (по операторам)',
  'analytics.kpi.newUsers': 'Новые пользователи',
  'analytics.kpi.newDrivers': 'Новые водители',
  'analytics.kpi.verifiedDrivers': 'Подтверждённые водители',
  'analytics.kpi.avgRating': 'Средний рейтинг',
  'analytics.kpi.avgTripPrice': 'Средняя цена',
  'analytics.kpi.avgTripDistance': 'Средняя дистанция (км)',
  'analytics.kpi.activeNow': 'Сейчас активно',
  'analytics.kpi.activeDrivers': 'Активные водители',
  'analytics.kpi.activeTrips': 'Активные поездки',

  'analytics.tab.overview': 'Обзор',
  'analytics.tab.revenue': 'Доход',
  'analytics.tab.trips': 'Поездки',
  'analytics.tab.users': 'Пользователи',
  'analytics.tab.drivers': 'Водители',
  'analytics.tab.regions': 'Регионы',
  'analytics.tab.promoRatings': 'Промо и рейтинги',
  'analytics.tab.operations': 'Операции',

  'analytics.chart.grossVsNet': 'Валовая выручка и чистая прибыль',
  'analytics.chart.revenueByService': 'Доход по типам услуг',
  'analytics.chart.paymentMethodShare': 'Способы оплаты',
  'analytics.chart.tripsBreakdown': 'Поездки по дням',
  'analytics.chart.tripsByService': 'Поездки по типам услуг',
  'analytics.chart.tariffBreakdown': 'Поездки по тарифам',
  'analytics.chart.tripsByHour': 'Поездки по часам',
  'analytics.chart.tripsByDayOfWeek': 'Поездки по дням недели',
  'analytics.chart.topRoutes': 'Популярные маршруты',
  'analytics.chart.serviceBreakdown': 'Распределение по услугам',
  'analytics.chart.ratingDistribution': 'Распределение рейтингов',
  'analytics.chart.activityScoreBuckets': 'Распределение активности',
  'analytics.chart.usersByRegion': 'Пользователи по регионам',

  'analytics.payouts.title': 'Выплаты — деньги, уходящие с платформы',
  'analytics.payouts.driverIncentives': 'Выплаты водителям',
  'analytics.payouts.userReferrals': 'Реферальные бонусы',
  'analytics.payouts.bonusCredits': 'Начисления бонусов',
  'analytics.payouts.bonusDebits': 'Списания бонусов',
  'analytics.payouts.refunds': 'Возвраты',
  'analytics.payouts.totalPaidOut': 'Всего выплачено',
  'analytics.payouts.topPrograms': 'Активные программы поощрений',
  'analytics.payouts.recipients': 'Получатели',
  'analytics.payouts.adminAdjustments': 'Корректировки от администратора',

  'analytics.table.topByTrips': 'Топ по поездкам',
  'analytics.table.topByEarnings': 'Топ по заработку',
  'analytics.table.topPromoCodes': 'Топ промокодов',
  'analytics.table.transactionTypes': 'Типы транзакций',
  'analytics.table.routeFrom': 'Откуда',
  'analytics.table.routeTo': 'Куда',
  'analytics.table.code': 'Код',
  'analytics.table.redemptions': 'Использовано',
  'analytics.table.totalDiscount': 'Сумма скидки',
  'analytics.table.region': 'Регион',
  'analytics.table.trips': 'Поездки',
  'analytics.table.grossRevenue': 'Валовая выручка',
  'analytics.table.netRevenue': 'Чистая выручка',
  'analytics.table.drivers': 'Водители',
  'analytics.table.clients': 'Клиенты',
  'analytics.table.completedTrips': 'Завершено',
  'analytics.table.earnings': 'Заработок',
  'analytics.table.rating': 'Рейтинг',
  'analytics.table.totalTrips': 'Всего поездок',
  'analytics.table.activityScore': 'Активность',
  'analytics.table.status': 'Статус',
  'analytics.table.count': 'Количество',
  'analytics.table.type': 'Тип',
  'analytics.table.amount': 'Сумма',
  'analytics.table.recipients': 'Получатели',
  'analytics.table.programName': 'Название программы',
  'analytics.table.bonusAmount': 'Сумма бонуса',

  'analytics.ops.verification': 'Проверка документов',
  'analytics.ops.pendingDocs': 'Ожидающие',
  'analytics.ops.approvedDocs': 'Одобрено',
  'analytics.ops.rejectedDocs': 'Отклонено',
  'analytics.ops.avgReviewHours': 'Среднее время проверки (ч)',
  'analytics.ops.support': 'Поддержка',
  'analytics.ops.openTickets': 'Открытые',
  'analytics.ops.inProgressTickets': 'В обработке',
  'analytics.ops.resolvedTickets': 'Решённые',
  'analytics.ops.avgResolutionHours': 'Среднее время решения (ч)',
  'analytics.ops.newTicketsInPeriod': 'Новые обращения за период',
  'analytics.ops.restingNow': 'Отдыхают',
  'analytics.ops.cancellationRate': 'Процент отмен водителями',
  'analytics.ops.walletBalances': 'Балансы кошельков (всего)',
  'analytics.ops.bonusBalances': 'Балансы бонусов (всего)',
  'analytics.ops.walletTopups': 'Пополнения кошельков',
  'analytics.ops.walletWithdrawals': 'Снятия с кошельков',

  'analytics.hours': 'ч',
  'analytics.trips': 'шт',
  'analytics.users': 'чел',
  'analytics.vs': 'против',
  'analytics.prevPeriod': 'предыдущий период',

  // ===== STAFF =====
  'staff.title': 'Сотрудники',
  'staff.newStaff': 'Новый сотрудник',
  'staff.basicInfo': 'Основная информация',
  'staff.login': 'Логин',
  'staff.password': 'Пароль',
  'staff.newPassword': 'Новый пароль',
  'staff.fullName': 'Полное имя',
  'staff.phone': 'Телефон',
  'staff.activeStatus': 'Активный статус',
  'staff.permissions': 'Разрешения',
  'staff.noPermissions': 'Нет разрешений',
  'staff.permissionGroups.users': 'Пользователи',
  'staff.permissionGroups.drivers': 'Водители',
  'staff.permissionGroups.documents': 'Документы',
  'staff.permissionGroups.trips': 'Поездки',
  'staff.permissionGroups.payments': 'Платежи',
  'staff.permissionGroups.support': 'Поддержка',
  'staff.permissionGroups.faq': 'FAQ',
  'staff.permissionGroups.promo': 'Промокоды',
  'staff.permissionGroups.settings': 'Настройки',
  'staff.permissionGroups.staff': 'Сотрудники',
  'staff.actions.read': 'Просмотр',
  'staff.actions.create': 'Создание',
  'staff.actions.update': 'Редактирование',
  'staff.actions.delete': 'Удаление',
  'staff.actions.block': 'Блокировка',
  'staff.actions.verify': 'Подтверждение',
  'staff.actions.review': 'Рассмотрение',
  'staff.actions.reply': 'Ответ',
  'staff.actions.resolve': 'Решение',
  'staff.actions.cancel': 'Отмена',
  'staff.lastLogin': 'Последний вход',
  'staff.activityLog': 'Журнал действий',

  // ===== PROMO CODES =====
  'promo.title': 'Промокоды',
  'promo.newPromo': 'Новый промокод',
  'promo.code': 'Код',
  'promo.type': 'Тип',
  'promo.value': 'Значение',
  'promo.usage': 'Использовано',
  'promo.validity': 'Срок действия',
  'promo.percentage': 'Процент',
  'promo.fixedAmount': 'Фиксированная сумма',
  'promo.maxUsages': 'Максимум использований',
  'promo.minTripAmount': 'Минимальная сумма поездки',
  'promo.maxDiscount': 'Максимальная скидка',
  'promo.startDate': 'Дата начала',
  'promo.endDate': 'Дата окончания',
  'promo.usageHistory': 'История использования',
  'promo.totalUsages': 'Всего использований',
  'promo.discount': 'Скидка',
  'promo.usedAt': 'Использован',
  'promo.toggleConfirm': 'Изменить статус промокода?',
  'promo.editPromo': 'Редактировать промокод',

  // ===== FAQ =====
  'faq.title': 'Часто задаваемые вопросы',
  'faq.newFaq': 'Новый вопрос',
  'faq.order': 'Порядок',
  'faq.question': 'Вопрос',
  'faq.answer': 'Ответ',
  'faq.category': 'Категория',
  'faq.questionUz': 'Вопрос (Узбекский)',
  'faq.answerUz': 'Ответ (Узбекский)',
  'faq.questionRu': 'Вопрос (Русский)',
  'faq.answerRu': 'Ответ (Русский)',
  'faq.questionEn': 'Вопрос (Английский)',
  'faq.answerEn': 'Ответ (Английский)',
  'faq.sortOrder': 'Порядок сортировки',
  'faq.visible': 'Видимый',
  'faq.hidden': 'Скрытый',

  // ===== CANCELLATION REASONS =====
  'cancelReasons.title': 'Причины отмены',
  'cancelReasons.new': 'Новая причина',
  'cancelReasons.type': 'Тип',
  'cancelReasons.reasonUz': 'Причина (Узбекский)',
  'cancelReasons.reasonRu': 'Причина (Русский)',
  'cancelReasons.reasonEn': 'Причина (Английский)',
  'cancelReasons.clientType': 'Для клиента',
  'cancelReasons.driverType': 'Для водителя',

  // ===== APP UPDATES =====
  'appUpdates.title': 'Обновления приложения',
  'appUpdates.new': 'Новое обновление',
  'appUpdates.version': 'Версия',
  'appUpdates.androidVersion': 'Версия Android',
  'appUpdates.iosVersion': 'Версия iOS',
  'appUpdates.mandatory': 'Обязательное',
  'appUpdates.optional': 'Необязательное',
  'appUpdates.storeUrls': 'Ссылки на магазины',
  'appUpdates.playStoreUrl': 'Ссылка Play Store',
  'appUpdates.appStoreUrl': 'Ссылка App Store',
  'appUpdates.releaseNotesUz': 'Описание (Узбекский)',
  'appUpdates.releaseNotesRu': 'Описание (Русский)',
  'appUpdates.releaseNotesEn': 'Описание (Английский)',
  'appUpdates.releaseProcess': 'Процесс выпуска',

  // ===== CAR BRANDS =====
  'carBrands.title': 'Марки автомобилей',
  'carBrands.brandsTab': 'Марки',
  'carBrands.modelsTab': 'Модели',
  'carBrands.brandName': 'Название марки',
  'carBrands.modelName': 'Название модели',
  'carBrands.modelCount': 'Количество моделей',
  'carBrands.sortOrder': 'Порядок сортировки',
  'carBrands.newBrand': 'Новая марка',
  'carBrands.editBrand': 'Редактировать марку',
  'carBrands.newModel': 'Новая модель',
  'carBrands.editModel': 'Редактировать модель',
  'carBrands.selectBrand': 'Выберите марку',

  // ===== OTP TOOL =====
  'otp.title': 'Отправить OTP',
  'otp.description': 'Если SMS с кодом не доходит до пользователя, отправьте код отсюда и продиктуйте его пользователю.',
  'otp.phoneLabel': 'Номер телефона',
  'otp.phoneRequired': 'Введите номер телефона',
  'otp.invalidPhone': 'Неверный формат номера. Пример: +998901234567',
  'otp.sendButton': 'Отправить OTP',
  'otp.codeLabel': 'Код OTP',
  'otp.expiresAt': 'Действителен до',
  'otp.smsStatus': 'Статус SMS',
  'otp.smsSent': 'Отправлено',
  'otp.smsNotSent': 'SMS не отправлено',
  'otp.smsFailedTitle': 'SMS не отправлено',
  'otp.smsFailedDesc': 'Код сохранён в базе и действителен 5 минут. Сообщите код пользователю устно или повторите позже.',
  'otp.success': 'OTP отправлен',
  'otp.smsFailedButCodeReady': 'SMS не отправлено, но код готов',
  'otp.copy': 'Копировать',
  'otp.copied': 'Скопировано',
  'otp.error': 'Произошла ошибка',

  // ===== INCENTIVES =====
  'incentives.title': 'Программы поощрения',
  'incentives.newProgram': 'Новая программа',
  'incentives.programName': 'Название программы',
  'incentives.goal': 'Цель',
  'incentives.period': 'Период',
  'incentives.tripTypes': 'Типы поездок',
  'incentives.participants': 'Участники',
  'incentives.completedCount': 'Выполнено',
  'incentives.totalPrograms': 'Всего программ',
  'incentives.activePrograms': 'Активные программы',
  'incentives.totalParticipants': 'Всего участников',
  'incentives.totalBonusPaid': 'Всего выплачено бонусов',
  'incentives.details': 'Подробности',
  'incentives.driverProgress': 'Прогресс водителя',
  'incentives.awardBonus': 'Выплатить бонус',
  'incentives.bonusAwarded': 'Бонус начислен',
  'incentives.bonusPaid': 'Бонус выплачен',
  'incentives.tripCountTarget': 'Целевое кол-во поездок',
  'incentives.bonusAmount': 'Сумма бонуса',
  'incentives.dateRange': 'Период',
  'incentives.expired': 'Истёк',

  // ===== REFERRALS =====
  'referrals.title': 'Реферальная программа',
  'referrals.config': 'Настройки',
  'referrals.referrer': 'Пригласивший',
  'referrals.referred': 'Приглашённый',
  'referrals.totalReferrals': 'Всего рефералов',
  'referrals.completed': 'Завершённые',
  'referrals.pending': 'Ожидающие',
  'referrals.thisMonth': 'В этом месяце',
  'referrals.conversionRate': 'Конверсия',
  'referrals.totalBonusPaid': 'Всего выплачено бонусов',
  'referrals.listTab': 'Список',
  'referrals.topReferrersTab': 'Лучшие рефереры',
  'referrals.configTab': 'Настройки',
  'referrals.payBonus': 'Выплатить бонус',
  'referrals.bonusPaid': 'Бонус выплачен',
  'referrals.configStatus': 'Статус программы',
  'referrals.minTrips': 'Минимум поездок',
  'referrals.passengerReferrerBonus': 'Бонус пригласившему пассажиру',
  'referrals.passengerReferredBonus': 'Бонус приглашённому пассажиру',
  'referrals.driverReferrerBonus': 'Бонус пригласившему водителю',
  'referrals.driverReferredBonus': 'Бонус приглашённому водителю',
  'referrals.passengerBonuses': 'Бонусы пассажиров',
  'referrals.driverBonuses': 'Бонусы водителей',

  // ===== PRICING =====
  'pricing.title': 'Ценообразование',
  'pricing.routesTab': 'Маршруты',
  'pricing.postageTab': 'Почта',
  'pricing.surgeTab': 'Surge',
  'pricing.settingsTab': 'Настройки',
  'pricing.basePricing': 'Базовые цены',
  'pricing.defaultPricePerKm': 'Стандартная цена за км',
  'pricing.newRoute': 'Новый маршрут',
  'pricing.editRoute': 'Редактировать маршрут',
  'pricing.fromRegion': 'Откуда (регион)',
  'pricing.toRegion': 'Куда (регион)',
  'pricing.fromCity': 'Откуда (город)',
  'pricing.toCity': 'Куда (город)',
  'pricing.tariffPrices': 'Тарифные цены',
  'pricing.econom': 'Эконом',
  'pricing.standard': 'Стандарт',
  'pricing.comfort': 'Комфорт',
  'pricing.business': 'Бизнес',
  'pricing.sevenPlus': '7+ мест',
  'pricing.minPrice': 'Минимальная цена',
  'pricing.maxPrice': 'Максимальная цена',
  'pricing.surgeMultiplier': 'Коэффициент Surge',
  'pricing.surgeRegion': 'Регион Surge',
  'pricing.multiplier': 'Коэффициент',
  'pricing.demandRatio': 'Уровень спроса',
  'pricing.recalculate': 'Пересчитать',
  'pricing.recalculateConfirm': 'Пересчитать цены?',
  'pricing.autoCalculationInfo': 'Цены рассчитываются автоматически',
  'pricing.priceOrderError': 'Цены должны быть в порядке: Эконом < Стандарт < Комфорт < Бизнес',
  'pricing.basePrice': 'Базовая цена',
  'pricing.pricePerKm': 'Цена за км',
  'pricing.nightTimeHint': 'Формат: ЧЧ:ММ (например, 22:00)',
  'pricing.surgeMinMaxError': 'Максимальная цена должна быть больше минимальной',
  'pricing.maxGteMin': 'Максимальная цена должна быть больше минимальной',

  // ===== LOCATIONS =====
  'locations.title': 'Локации',
  'locations.regionsTab': 'Регионы',
  'locations.citiesDistrictsTab': 'Города и районы',
  'locations.popularTab': 'Популярные',
  'locations.boundariesTab': 'Границы',
  'locations.regions': 'Регионы',
  'locations.cities': 'Города',
  'locations.districts': 'Районы',
  'locations.nameUz': 'Название (Узбекский)',
  'locations.nameRu': 'Название (Русский)',
  'locations.nameEn': 'Название (Английский)',
  'locations.code': 'Код',
  'locations.hasBoundary': 'Есть граница',
  'locations.citiesCount': 'Количество городов',
  'locations.districtsCount': 'Количество районов',
  'locations.boundary': 'Граница',
  'locations.viewOnMap': 'Посмотреть на карте',
  'locations.uploadGeoJson': 'Загрузить GeoJSON',
  'locations.deleteBoundary': 'Удалить границу',
  'locations.importBoundaries': 'Импорт границ',
  'locations.matchConfidence': 'Точность совпадения',
  'locations.popularDestinations': 'Популярные направления',
  'locations.icon': 'Иконка',
  'locations.coordinates': 'Координаты',
  'locations.lat': 'Широта',
  'locations.lng': 'Долгота',
  'locations.boundariesMap': 'Карта границ',
  'locations.showRegions': 'Показать регионы',
  'locations.showCities': 'Показать города',
  'locations.showDistricts': 'Показать районы',

  // ----- Locations page extended (page-level strings) -----
  'locations.id': 'ID',
  'locations.actions': 'Действия',
  'locations.type': 'Тип',
  'locations.yes': 'Есть',
  'locations.no': 'Нет',
  'locations.active': 'Активно',
  'locations.inactive': 'Неактивно',
  'locations.status': 'Статус',
  'locations.sortOrder': 'Порядок',
  'locations.sortOrderNumber': 'Номер порядка',
  'locations.region': 'Регион',
  'locations.city': 'Город',
  'locations.district': 'Район',
  'locations.mapTab': 'Карта',
  'locations.locationManagement': 'Управление локациями',
  'locations.save': 'Сохранить',
  'locations.create': 'Создать',
  'locations.cancel': 'Отмена',
  'locations.add': 'Добавить',
  'locations.loading': 'Загрузка...',
  'locations.refresh': 'Обновить',
  'locations.retry': 'Повторить',
  'locations.errorLabel': 'Ошибка',
  'locations.errorOccurred': 'Произошла ошибка',
  'locations.dataLoadError': 'Ошибка загрузки данных',
  'locations.regionsLoadError': 'Ошибка загрузки регионов',
  'locations.boundariesLoadError': 'Ошибка загрузки границ',
  'locations.confirmDelete': 'Подтверждаете удаление?',
  'locations.enterName': 'Введите название',
  'locations.enterValue': 'Введите',
  'locations.selectRegion': 'Выберите регион',
  'locations.selectCity': 'Выберите город',
  'locations.selectDistrict': 'Выберите район',
  'locations.filters': 'Фильтры:',
  'locations.newRegion': 'Новый регион',
  'locations.editRegion': 'Редактировать регион',
  'locations.regionCreated': 'Регион создан',
  'locations.regionUpdated': 'Регион обновлён',
  'locations.regionDeleted': 'Регион удалён',
  'locations.newCityDistrict': 'Новый город/район',
  'locations.editCity': 'Редактировать город',
  'locations.editDistrict': 'Редактировать район',
  'locations.cityCreated': 'Город создан',
  'locations.cityUpdated': 'Город обновлён',
  'locations.cityDeleted': 'Город удалён',
  'locations.districtCreated': 'Район создан',
  'locations.districtUpdated': 'Район обновлён',
  'locations.districtDeleted': 'Район удалён',
  'locations.citiesWord': 'город(ов)',
  'locations.districtsWord': 'район(ов)',
  'locations.newDestination': 'Новое направление',
  'locations.newPopularDestination': 'Новое популярное направление',
  'locations.editDestination': 'Редактировать направление',
  'locations.destinationCreated': 'Направление создано',
  'locations.destinationUpdated': 'Направление обновлено',
  'locations.destinationDeleted': 'Направление удалено',
  'locations.addFirstDestination': 'Добавить первое направление',
  'locations.noRegionsFound': 'Регионы не найдены',
  'locations.noCitiesOrDistrictsInRegion': 'В этом регионе нет городов или районов',
  'locations.noPopularInCity': 'В этом городе ещё нет популярных направлений.',
  'locations.noPopularInDistrict': 'В этом районе ещё нет популярных направлений.',
  'locations.noBoundariesFound': 'Границы не найдены. Сначала добавьте границы к регионам, городам или районам.',
  'locations.latitude': 'Широта (Latitude)',
  'locations.longitude': 'Долгота (Longitude)',
  'locations.optionalCode': 'Код (необязательно)',
  'locations.optionalIconName': 'Название иконки (необязательно)',
  'locations.totalDestinationsSummaryPrefix': 'Всего:',
  'locations.destinationsWord': 'популярных направлений,',
  'locations.regionsWord': 'регион(ов)',
  'locations.boundariesWord': 'границ',

  // ===== LOGIN =====
  'login.title': 'Вход в панель управления',
  'login.username': 'Логин',
  'login.password': 'Пароль',
  'login.submit': 'Войти',
  'login.error': 'Неверный логин или пароль',

  // ===== SERVICES =====
  'service.taxi': 'Такси',
  'service.bus': 'Автобус',
  'service.cargo': 'Грузы',
  'service.taxiDescription': 'Управление службой такси',
  'service.busDescription': 'Управление автобусными перевозками',
  'service.cargoDescription': 'Управление грузовыми перевозками',
  'service.comingSoon': 'Скоро',

  // ===== FILTERS =====
  'filters.advancedFilter': 'Расширенный фильтр',
  'filters.clear': 'Сбросить',
  'filters.apply': 'Применить',
  'filters.verificationStatus': 'Статус верификации',
  'filters.driverVerified': 'Подтверждённые водители',
  'filters.tripStatistics': 'Статистика поездок',
  'filters.tripCount': 'Количество поездок',
  'filters.minTrips': 'Минимум поездок',
  'filters.maxTrips': 'Максимум поездок',
  'filters.hasCompletedTrips': 'Есть завершённые поездки',
  'filters.yesCompleted': 'Да, есть',
  'filters.noCompleted': 'Нет',
  'filters.minRating': 'Минимальный рейтинг',
  'filters.maxRating': 'Максимальный рейтинг',
  'filters.registrationDate': 'Дата регистрации',
  'filters.from': 'От',
  'filters.to': 'До',
  'filters.blockedUsers': 'Заблокированные пользователи',
  'filters.onlyBlocked': 'Только заблокированные',
  'filters.onlyNotBlocked': 'Только незаблокированные',
  'filters.vehicleStatus': 'Статус автомобиля',
  'filters.hasVehicle': 'Есть автомобиль',
  'filters.noVehicle': 'Нет автомобиля',
  'filters.homeRegion': 'Регион',
  'filters.allRegions': 'Все регионы',

  // ===== BUS MODULE =====
  'bus.companies': 'Компании',
  'bus.trips': 'Рейсы',
  'bus.bookings': 'Бронирования',
  'bus.staff': 'Сотрудники',
  'bus.settings': 'Настройки',
  'bus.reports': 'Отчёты',
  'bus.analytics': 'Аналитика',
  'bus.companyName': 'Название компании',
  'bus.legalName': 'Юридическое название',
  'bus.commission': 'Комиссия',
  'bus.tripCount': 'Количество рейсов',
  'bus.newCompany': 'Новая компания',
  'bus.blockCompany': 'Заблокировать компанию',
  'bus.unblockCompany': 'Разблокировать компанию',
  'bus.blockReason': 'Причина блокировки',
  'bus.route': 'Маршрут',
  'bus.departureTime': 'Время отправления',
  'bus.arrivalTime': 'Время прибытия',
  'bus.seats': 'Места',
  'bus.availableSeats': 'Свободные места',
  'bus.pricePerSeat': 'Цена за место',
  'bus.busType': 'Тип автобуса',
  'bus.busNumber': 'Номер автобуса',
  'bus.standard': 'Стандарт',
  'bus.comfort': 'Комфорт',
  'bus.vip': 'VIP',
  'bus.stations': 'Станции',
  'bus.layouts': 'Схемы',
  'bus.seatEditor': 'Редактор мест',
  'bus.bookingCode': 'Код бронирования',
  'bus.passenger': 'Пассажир',
  'bus.seatNumbers': 'Номера мест',
  'bus.totalPrice': 'Общая стоимость',
  'bus.confirmPayment': 'Подтвердить оплату',
  'bus.cancelBooking': 'Отменить бронирование',
  'bus.cancelReason': 'Причина отмены',
  'bus.downloadPassengerList': 'Скачать список пассажиров',
  'bus.createBooking': 'Создать бронирование',
  'bus.stationName': 'Название станции',
  'bus.address': 'Адрес',
  'bus.layoutName': 'Название схемы',
  'bus.totalSeats': 'Всего мест',
  'bus.seatSchema': 'Схема мест',

  // ===== DRIVER JOURNEY STAGES =====
  'drivers.pushNotification': 'Push',
  'drivers.journeyStages': 'Этапы в приложении',
  'drivers.stageRegistration': 'Регистрация',
  'drivers.stageNameEntered': 'Имя указано',
  'drivers.stageVehicleAdded': 'Автомобиль добавлен',
  'drivers.stageDocumentsUploaded': 'Документы загружены',
  'drivers.stageDocumentsApproved': 'Документы одобрены',
  'drivers.stageDriverVerified': 'Водитель подтверждён',
  'drivers.stagePushEnabled': 'Push-уведомления',
  'drivers.stageFirstTrip': 'Первая поездка',
  'drivers.stageCompleted': 'Выполнено',
  'drivers.stagePending': 'Ожидается',
  'drivers.stageFailed': 'Отклонено',
  'filters.hasPush': 'Push включён',
  'filters.noPush': 'Push отсутствует',

  // ===== CALL NOTES ANALYTICS =====
  'common.refresh': 'Обновить',
  'callNotesAnalytics.title': 'Аналитика операторских звонков',
  'callNotesAnalytics.totalInPeriod': 'Звонков за период',
  'callNotesAnalytics.allTime': 'За всё время',
  'callNotesAnalytics.avgPerDay': 'Средн./день',
  'callNotesAnalytics.days': 'дней',
  'callNotesAnalytics.uniqueOperators': 'Операторов',
  'callNotesAnalytics.uniqueUsersCalled': 'Уник. пользователей',
  'callNotesAnalytics.taggedUsers': 'С цветной меткой',
  'callNotesAnalytics.dailyTrend': 'Звонки по дням',
  'callNotesAnalytics.colorDistribution': 'Распределение по меткам',
  'callNotesAnalytics.topOperators': 'Топ операторы',
  'callNotesAnalytics.topUsers': 'Топ пользователи (по числу звонков)',
  'callNotesAnalytics.recentNotes': 'Последние заметки',
  'callNotesAnalytics.notes': 'Заметок',
  'callNotesAnalytics.note': 'Заметка',
  'callNotesAnalytics.operator': 'Оператор',
  'callNotesAnalytics.user': 'Пользователь',
  'callNotesAnalytics.phone': 'Телефон',
  'callNotesAnalytics.role': 'Роль',
  'callNotesAnalytics.when': 'Когда',
  'callNotesAnalytics.noData': 'Нет данных за выбранный период',
};
